import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

function getElectronicCommercialInvoice(row: FulfillmentGroupData): string {
  if (!row?.shipment?.label?.commercialInvoiceUrl) {
    return "N/A";
  }

  return row?.shipment?.label?.comInvoiceSubmittedElectronically
    ? "true"
    : "false";
}

export const CommercialInvoiceSubmittedElectronicallyCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Comm. invoice e-submitted",
    cell: (row) => {
      return getElectronicCommercialInvoice(row);
    },
  };
